import Link, { LinkProps } from 'next/link';
import { classnames } from '@/utils/classnames';

export interface IUnderlinedTextLinkProps
  extends LinkProps,
    Pick<TAnchorProps, 'className' | 'children'> {}

const UnderlinedTextLink = ({
  className,
  children,
  ...rest
}: IUnderlinedTextLinkProps) => {
  return (
    <Link
      className={classnames(
        'font-demibold text-blue underline decoration-blue underline-offset-[3px]',
        className
      )}
      {...rest}
    >
      {children}
    </Link>
  );
};
export default UnderlinedTextLink;
